import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { AppService } from '../../../../../services';
import { DeliveryAreaService } from '../../../delivery-area.service';
import { DeliveryAcceleratorsService } from '../../delivery-accelerators.service';
import { getSetup } from './grid/get-setup';

@Component({
	selector: 'delivery-accelerators-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './accelerators-views.part.html',
})
export class DeliveryAcceleratorsViewPart {

	private readonly util = inject(UtilityService);
	private readonly router = inject(Router);
	private readonly app = inject(AppService);
	private readonly areaService = inject(DeliveryAreaService);
	private readonly pageService = inject(DeliveryAcceleratorsService);

	public setup = getSetup(this.util, this.app, this.router);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public accelerators = computed(() => {
		const accelerators = this.areaService.deliveryData()?.accelerators;
		if (!accelerators) return [];

		return accelerators.map(a => {
			const formattedData = this.util.date.formatAccMeetingSlot(a.meetingStartSlot, a.standardFourTimeZoneId, true, this.app.data().standardLocalTimezoneId)
			return {
				...a,
				meetingAcceleratorDisplayText: formattedData.acceleratorDisplayTime,
				meetingLocalDisplayText: formattedData.localDisplayTime
			};
		})
	});


}